export const useMockedUser = () => {

  var item_value = JSON.parse(sessionStorage.getItem("userDetails"));

  var retData = {
    id: item_value.userId,
    avatar: '/assets/avatars/avatar-anika-visser.png',
    name: item_value.userFirstName,
    email: item_value.userEmail,
    firstName: item_value.userFirstName,
    middleName: item_value.userMiddleName,
    lastName: item_value.userLastName
  }

  return retData
};
